import React, { FC } from "react";

import { Grid } from "@mui/material";

const GridLineBreak: FC = () => <Grid item xs={12} style={{ paddingTop: "0", paddingLeft: "0" }} />;

export default GridLineBreak;
